/**
 * Aura Fade Animation
 * Handle scroll-triggered fade animations with staggered delays
 */

const observerOptions = {
  root: null,
  rootMargin: '0px 0px -10% 0px', // Trigger slightly before element is fully in view
  threshold: 0.1,
};

const fadeObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('fadeIn');
      fadeObserver.unobserve(entry.target);
    }
  });
}, observerOptions);

const initFadeAnimations = () => {
  // 1. Auto-apply preFade to text elements inside containers with opt-in attribute
  const textContainers = document.querySelectorAll('[data-aura-animate="true"]');

  textContainers.forEach((container) => {
    // Select direct text children or nested text elements
    // Extended selector to include more element types that might need fading
    const elements = container.querySelectorAll(
      'h1, h2, h3, h4, h5, h6, p, li, a.btn, .c-rich-textbox > *',
    );

    // Filter out elements that shouldn't be animated (e.g. inside excluded containers)
    const validElements = Array.from(elements).filter((el) => {
      // Avoid animating elements that are already handled or inside a nested animate container
      if (el.classList.contains('preFade')) return false;
      if (el.closest('[data-aura-animate="true"]') !== container) return false;
      return true;
    });

    validElements.forEach((el, index) => {
      el.classList.add('preFade');
      // Apply staggered delay (0.05s per item)
      el.style.transitionDelay = `${index * 0.05}s`;
    });
  });

  // 2. Observe all preFade elements
  document.querySelectorAll('.preFade').forEach((el) => {
    fadeObserver.observe(el);
  });
};

// Run on load and support Turbo/Htmx if needed
document.addEventListener('DOMContentLoaded', initFadeAnimations);

// If using Alpine.js or other frameworks that dynamically load content,
// you might want to expose this function globally
window.initFadeAnimations = initFadeAnimations;
